import {
    Dashboard as DashboardIcon,
    People as PeopleIcon,
    Receipt as ReceiptIcon,
    CreditCard as CreditCardIcon,
    HelpOutline as HelpOutlineIcon,
    Settings as SettingsIcon,
    Notifications as NotificationsIcon,
    Slideshow as SlideshowIcon,
    Summarize as SummarizeIcon,
    Assessment as AssessmentIcon,
    Update,
} from '@mui/icons-material';

export const menuItems = [
    {
        label: "Dashboard",
        icon: DashboardIcon,
        path: "/dashboard",
    },
    {
        label: "Users",
        icon: PeopleIcon,
        path: "/user",
    },
    {
        label: "Transaction",
        icon: ReceiptIcon,
        children: [
            { label: "Report", path: "/report", icon: SummarizeIcon },
            { label: "Summary", path: "/summary", icon: AssessmentIcon },
        ],
    },
    {
        label: "Cheque Service",
        icon: CreditCardIcon,
        path: "/cheque-service",
    },
    {
        label: "Request Send",
        icon: HelpOutlineIcon,
        path: "/request",
    },
    {
        label: "Credit Management",
        icon: CreditCardIcon,
        path: "/credit-management",
    },
    {
        label: "Notification",
        icon: NotificationsIcon,
        path: "/notification",
    },
    {
        label: "Slider",
        icon: SlideshowIcon,
        path: "/slider",
    },
    {
        label: "Setting",
        icon: SettingsIcon,
        children: [
            { label: "Change Password", action: "changePassword", icon: Update },
        ],
    },
    {
        label: "User Manual",
        icon: HelpOutlineIcon,
        externalLink: "https://docs.google.com/document/d/17MMJ7YbpxNNiMoIfuK2JK-6BZ1kH8yIu71f8B4JSe8Y/edit?usp=sharing",
    },
];
